/* eslint-disable react/no-multi-comp */
import cx from 'classnames';
import { NotEqual } from 'education-icons';
import React from 'react';
import { useMeasure } from 'react-use';

import { useIntl } from '../../intl/context';
import { MarkdownExtXContent } from '../../markdown/markdown';
import { monospace } from '../../robot/font';
import { WebTestError } from '../types';

// @ts-ignore
import styles from './web-problem__error.module.scss';

const HIDE_WIDTH = 400;

interface Props {
    className?: string;
    error: WebTestError;
}

const WebError = ({ className, error }: Props) => {
    const [ref, bounds] = useMeasure<HTMLDivElement>();
    const showIcon = bounds.width > HIDE_WIDTH;

    const intl = useIntl();

    let message;
    if (typeof error === 'string') {
        message = intl.formatMessage({ id: error });
    } else {
        message = intl.formatMessage({ id: error.id }, error.values);
    }

    return (
        <div className={cx(styles.error, className, monospace)} ref={ref}>
            {showIcon && <NotEqual className={styles.error__icon} />}
            <MarkdownExtXContent>{message}</MarkdownExtXContent>
        </div>
    );
};

export const WebProblemError = React.memo(WebError);
